/**
 * 🌍 GLOBAL STANDART KOD (TÜM PROJELER İÇİN GEÇERLİDİR)
 *
 * Responsive davranış kararlarını render sırasında doğrudan `window.innerWidth`
 * okumalarına bırakmaz. Media query değişimini React state'ine taşıyarak görsel
 * durum, erişilebilir ad ve etkileşim sözleşmesinin aynı anda güncellenmesini
 * sağlar.
 */

import { useEffect, useState } from 'react';

function readMediaQuery(query: string): boolean {
  return typeof window !== 'undefined'
    && typeof window.matchMedia === 'function'
    && window.matchMedia(query).matches;
}

export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => readMediaQuery(query));

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
      return undefined;
    }

    const mediaQuery = window.matchMedia(query);
    const handleChange = (event: MediaQueryListEvent) => setMatches(event.matches);

    setMatches(mediaQuery.matches);
    mediaQuery.addEventListener('change', handleChange);

    return () => mediaQuery.removeEventListener('change', handleChange);
  }, [query]);

  return matches;
}

export function useIsMobileViewport(): boolean {
  return useMediaQuery('(max-width: 768px)');
}
